class BaseTrackingProvider {
  userId = null
  sessionId = null

  constructor () {
    if (new.target === BaseTrackingProvider) {
      throw new TypeError('Cannot instantiate ' + new.target + ' directly')
    }
    const proto = Object.getPrototypeOf(this)
    const missing = ['optIn', 'optOut', 'trackEvent', 'trackPageView', 'hasConsented'].find(name => !proto.hasOwnProperty(name))
    if (missing) throw new TypeError(`${this.constructor.name} needs to implement ${missing}`)

  }

  setUserId (userId) {
    this.userId = userId
  }

  setSessionId (sessionId) {
    this.sessionId = sessionId
  }

  getOptsWithDefaults (opts = {}) {
    return {
      ...opts,
      ...{
        sessionId: this.sessionId,
        userId: this.userId,
      }
    }
  }

  /**
   * @returns void
   */
  optIn () {
    throw new Error('optIn method needs to be implemented')
  }

  /**
   * @returns void
   */
  optOut () {
    throw new Error('optOut method needs to be implemented')
  }

  /**
   * @param eventName string
   * @param eventOpts Object
   * @returns void
   */
  trackEvent (eventName, eventOpts = {}) {
    throw new Error('trackEvent method needs to be implemented')
  }

  /**
   * @param pageName string
   * @param pageViewOpts Object
   * @returns void
   */
  trackPageView (pageName, pageViewOpts = {}) {
    throw new Error('trackPageView method needs to be implemented')
  }

  /**
   * @returns {boolean}
   */
  hasConsented () {
    throw new Error('hasConsented method needs to be implemented')
  }
}

export default BaseTrackingProvider
